(ns manage.variants-preview-panel.variant-id-table.db
  (:require [common.db.table.backend :as b :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]
            [re-frame.core :as rf]))

(def backend
  (map->InMemoryBackend {}))

(register-table
 {:namespace :table.variant-id
  :value-sub [:variants-preview.variants/values]
  :initial-page {}
  :initial-search {}
  :initial-sort {}
  :initial-filters {:status ["draft" "approved" "published"]}
  :backend backend})

(defn apply-min-score [min-score x]
  (if (some? min-score)
    (update x :value (fn [values]
                       (filter (fn [{:keys [score]}]
                                 (>= score min-score))
                               values)))
    x))

(defn apply-status [filter-status x]
  (if (some? filter-status)
    (update x :value (fn [values]
                       (filter (fn [{:keys [status]}]
                                 (some #(= status %) filter-status))
                               values)))
    x))

;; Custom min-score filtering for create-lift poc
(rf/reg-sub :table.variant-id/unpaginated-value
  :<- [:table.variant-id/search]
  :<- [:table.variant-id/sort]
  :<- [:table.variant-id/hidden]
  :<- [:table.variant-id/filters]
  :<- [:variants-preview.variants/values]
  (fn [[search sort hidden filters value]]
    (->> value
         (b/apply-filter backend (:column search) (:term search))
         (apply-min-score (:min-score filters))
         (apply-status (:status filters))
         (b/apply-sorting backend (:column sort) (:direction sort))
         (b/apply-hidden backend (:column hidden) (:hidden? hidden)))))

(rf/reg-event-fx :table.variant-id/select-all-rows
  [(rf/inject-cofx :sub :table.variant-id/unpaginated-value)]
  (fn [{:keys [db]
        :table.variant-id/keys [unpaginated-value]}]
    {:db (assoc-in db [:table.variant-id :selected-rows] (set (map :id (:value unpaginated-value))))}))

(rf/reg-event-fx :table.variant-id/load-more-variants
  (fn [{:keys [db]}]
    (let [last-cursor (get-in db [:variants-preview.variants :last-cursor])]
      {:dispatch [:resource.content-variants/get-variants-for-preview last-cursor]})))
